var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alert-derivation" }, [
    _c("h4", { staticClass: "is-uppercase title" }, [
      _vm._v("Informar a Equipo")
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "description" }, [
      _vm._v(
        "\n    El responsable del alumno será informado de manera automática. En caso de querer informar a\n    alguien más, por favor, seleccionar.\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "derivations" },
      [
        _vm._l(_vm.items, function(d, index) {
          return _c("div", { key: d.id, staticClass: "derivation" }, [
            _c("div", [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "multiselect-container" },
                  [
                    _c("multiselect", {
                      attrs: { "options-list": _vm.users },
                      model: {
                        value: d.chosenUser,
                        callback: function($$v) {
                          _vm.$set(d, "chosenUser", $$v)
                        },
                        expression: "d.chosenUser"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button",
                    on: {
                      click: function($event) {
                        return _vm.removeDerivation(index)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "icon icon-svg",
                      attrs: {
                        src: require("@/static/svg/icono_basura.svg"),
                        alt: "next"
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: d.message,
                  expression: "d.message"
                }
              ],
              attrs: {
                placeholder:
                  "Comentario personal para usuario a informar (máx 140 caracteres)."
              },
              domProps: { value: d.message },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(d, "message", $event.target.value)
                }
              }
            })
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary is-outlined add-derivation",
              on: { click: _vm.addDerivation }
            },
            [_vm._v("\n        +\n      ")]
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }